import { EllipsisHorizontalCircleIcon } from "@heroicons/react/24/outline";
import { CircleStackIcon, UserIcon } from "@heroicons/react/24/solid";
import React from "react";
import EllipsisDetailsCard from "../EllipsisDetailsCard";
import "./../css/OHOrgChartNode.css";

const OHSalesOrgChartNode = (props) => {
  // Function to determine background color based on title
  const determineColors = (parentId, areaType, districtType) => {
    if (parentId === "") {
      return { backgroundColor: "#ECF9FF", textColor: "#203a75" }; // Color for Chief Sales Officer
    } else if (parentId === "1") {
      return { backgroundColor: "#ECF9FF", textColor: "#0C77BD" }; // Color for President, Sales
    } else if (parentId === "2") {
      return { backgroundColor: "#ECF9FF", textColor: "#269ca0" }; // Color for President, Sales
    } else if (parentId === "3") {
      return { backgroundColor: "#ECF9FF", textColor: "#f05a67" }; // Color for President, Sales
    } else if (parentId === "4") {
      return { backgroundColor: "#ECF9FF", textColor: "#069edb" }; // Color for President, Sales
    } else if (areaType === "Area") {
      return { backgroundColor: "#ECF9FF", textColor: "#069EDB" }; // Color for VP, Sales
    }
    // Default color for other titles
    return { backgroundColor: "#ECF9FF", textColor: "#000" }; // You can adjust the default text color
  };

  //#region  styles
  const { backgroundColor, textColor } = determineColors(
    props.node.data.parentId,
    props.node.data.areaType,
    props.node.data.districtType
  );

  const wrapper = {
    display: "flex",
    flexDirection: "column",
  };

  const chiefSales = {
    backgroundColor: "#203a75",
    boxShadow:
      "0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 2px 1px -1px rgb(0 0 0 / 12%)",
    borderRadius: "20px",
    cursor: "default",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    paddingTop: "0",
    paddingBottom: "22px",
  };

  const nsaPresident = {
    backgroundColor: "#0c77bd",
    boxShadow:
      "0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 2px 1px -1px rgb(0 0 0 / 12%)",
    borderRadius: "20px",
    cursor: "default",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    paddingTop: "0",
  };

  const splcPresident = {
    backgroundColor: "#269ca0",
    boxShadow:
      "0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 2px 1px -1px rgb(0 0 0 / 12%)",
    borderRadius: "20px",
    cursor: "default",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    paddingTop: "0",
  };

  const dsPresident = {
    backgroundColor: "#f05a67",
    boxShadow:
      "0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 2px 1px -1px rgb(0 0 0 / 12%)",
    borderRadius: "20px",
    cursor: "default",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    paddingTop: "0",
  };

  const vicePresident = {
    backgroundColor: "#069EDB",
    boxShadow:
      "0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 2px 1px -1px rgb(0 0 0 / 12%)",
    borderRadius: "20px",
    cursor: "default",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    paddingTop: "0",
  };

  const nameEllipsis = {
    border: "none",
    overflow: "hidden",
    outline: "none",
    margin: "5px",
    lineHeight: "30px",
    width: "95%",
    borderRadius: "10px",
    display: "flex",
    backgroundColor: backgroundColor,
    color: textColor,
    marginLeft: "-15px",
    marginTop: "22px",
  };

  const chiefNameEllipsis = {
    border: "none",
    overflow: "hidden",
    outline: "none",
    margin: "5px",
    lineHeight: "30px",
    width: "95%",
    borderRadius: "10px",
    display: "flex",
    backgroundColor: backgroundColor,
    color: textColor,
    marginLeft: "-15px",
    marginTop: "22px",
  };

  const chiefCardEllipsis = {
    right: "45px",
    position: "absolute",
    top: "14px",
    width: "25px",
    marginTop: "12px",
  };

  const cardEllipsis = {
    right: "45px",
    position: "absolute",
    top: "14px",
    width: "25px",
    marginTop: "12px",
  };

  const cardName = {
    border: "none",
    overflow: "hidden",
    outline: "none",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginLeft: "35px",
  };

  const chiefCardName = {
    border: "none",
    overflow: "hidden",
    outline: "none",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginLeft: "35px",
  };

  const cardNameH3 = {
    fontSize: "18px",
    cursor: "pointer",
    fontWeight: "bold",
    border: "none",
    textAlign: "center",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    margin: "0",
  };

  const cardType = {
    height: "auto",
    color: "#fff",
    borderRadius: "30px",
    fontSize: "14px",
    fontWeight: "bold",
    marginLeft: "18px",
  };

  const chiefCardType = {
    height: "auto",
    color: "#fff",
    borderRadius: "30px",
    fontSize: "14px",
    fontWeight: "bold",
    marginLeft: "18px",
  };

  const officeHierarchy = {
    display: "flex",
    padding: "12px",
    paddingLeft: "20px",
    paddingTop: "3px",
    minWidth: "70px",
    height: "auto",
    color: "#fff",
    borderRadius: "30px",
    fontSize: "14px",
  };

  const ellipsis = {
    borderRadius: "9999px",
    width: "1.5rem",
    height: "1.5rem",
  };

  const nsaCard = {
    backgroundColor: "#0c77bd",
    border: "1px solid #0c77bd",
    color: "#0c77bd",
    // boxShadow: "5px 5px 0px 0px rgba(12, 119, 189)",
    overflow: "hidden",
    outline: "#0c77bd",
    alignSelf: "center",
    lineHeight: "30px",
    width: "290px",
    height: "100px",
    borderRadius: "20px",
    marginTop: "5px",
    padding: "10px",
    boxSizing: "border-box",
  };

  const splcCard = {
    backgroundColor: "#269ca0",
    border: "1px solid #269ca0",
    color: "#269ca0",
    // boxShadow: "5px 5px 0px 0px rgba(38, 156, 160)",
    overflow: "hidden",
    outline: "#269ca0",
    alignSelf: "center",
    lineHeight: "30px",
    width: "290px",
    height: "100px",
    borderRadius: "20px",
    marginTop: "5px",
    padding: "10px",
    boxSizing: "border-box",
  };

  const dsCard = {
    backgroundColor: "#f05a67",
    border: "1px solid #f05a67",
    color: "#f05a67",
    // boxShadow: "5px 5px 0px 0px rgba(240, 90, 103)",
    overflow: "hidden",
    outline: "#f05a67",
    alignSelf: "center",
    lineHeight: "30px",
    width: "290px",
    height: "100px",
    borderRadius: "20px",
    marginTop: "5px",
    padding: "10px",
    boxSizing: "border-box",
  };

  const cardH3 = {
    fontSize: "20px",
    cursor: "pointer",
    fontWeight: "bold",
    border: "none",
    textAlign: "center",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    backgroundColor: "#ECF9FF",
    borderRadius: "5px 20px 20px 5px",
    marginTop: "15px",
    marginRight: "1rem",
    height: "50px",
    alignContent: "center",
  };

  const nsasplcdsCard = {
    backgroundColor: "#0c77bd",
    border: "1px solid #0c77bd",
    color: "#0c77bd",
    // boxShadow: "5px 5px 0px 0px rgba(12, 119, 189)",
    overflow: "hidden",
    outline: "#0c77bd",
    alignSelf: "center",
    lineHeight: "30px",
    width: "350px",
    height: "100px",
    borderRadius: "20px",
    marginTop: "5px",
    padding: "10px",
    boxSizing: "border-box",
  };
  const iconUser = {
    alignSelf: "left",
    right: "270px",
    position: "absolute",
    top: "16px",
    width: "0px",
    borderWidth: "8px",
    borderColor: backgroundColor,
    backgroundColor: textColor,
    borderRadius: "9999px",
    borderStyle: "solid",
    padding: "1.5rem",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    height: "33px",
    boxSizing: "unset",
  };

  const chiefIconUser = {
    alignSelf: "left",
    right: "270px",
    position: "absolute",
    top: "16px",
    width: "0px",
    borderWidth: "8px",
    borderColor: "#ECF9FF",
    backgroundColor: "#203A75",
    borderRadius: "9999px",
    borderStyle: "solid",
    padding: "1.5rem",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    height: "33px",
    boxSizing: "unset",
  };

  const iconStack = {
    alignSelf: "left",
    right: "245px",
    position: "absolute",
    top: "6px",
    width: "0px",
    borderWidth: "8px",
    borderColor: "#ECF9FF",
    marginTop: "20px",
    marginRight: "16px",
    borderRadius: "9999px",
    borderStyle: "solid",
    padding: "1.5rem",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    backgroundColor: "#203A75",
    height: "33px",
    boxSizing: "unset",
  };

  const iconStack2 = {
    alignSelf: "left",
    right: "245px",
    position: "absolute",
    top: "6px",
    width: "0px",
    borderWidth: "8px",
    borderColor: "#ECF9FF",
    marginTop: "20px",
    marginRight: "70px",
    borderRadius: "9999px",
    borderStyle: "solid",
    padding: "1.5rem",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    backgroundColor: "#203A75",
    height: "33px",
    boxSizing: "unset",
  };

  const user = {
    borderRadius: "9999px",
    width: "2rem",
    height: "2rem",
    marginLeft: "-16px",
    color: "#ECF9FF",
  };
  //#endregion
  return (
    <>
      <div
        style={
          props.node.data.id === 1283
            ? chiefSales
            : props.node.data.parentId === "1" ||
              props.node.data.parentId === "4"
            ? nsaPresident
            : props.node.data.parentId === "2"
            ? splcPresident
            : props.node.data.parentId === "3"
            ? dsPresident
            : props.node.data.areaType === "Area"
            ? vicePresident
            : wrapper
        }
      >
        {props.node.data.id === 1 ||
        props.node.data.id === 2 ||
        props.node.data.id === 3 ||
        props.node.data.id === 4 ? (
          <div
            className={
              props.node.data.id === 1
                ? "node-card__nsa"
                : props.node.data.id === 2
                ? "node-card__splc"
                : props.node.data.id === 3
                ? "node-card__ds"
                : props.node.data.id === 4
                ? "node-card__nsa"
                : ""
            }
            style={
              props.node.data.id === 1
                ? nsaCard
                : props.node.data.id === 2
                ? splcCard
                : props.node.data.id === 3
                ? dsCard
                : props.node.data.id === 4
                ? nsasplcdsCard
                : ""
            }
          >
            <div
              className="rounded-full bg-primary p-6 py-2"
              style={
                props.node.data.id === 1 ||
                props.node.data.id === 2 ||
                props.node.data.id === 3
                  ? iconStack
                  : iconStack2
              }
            >
              <CircleStackIcon
                className={`text-chartColor rounded-full bg-primary`}
                style={user}
              />
            </div>
            <h3 style={cardH3}>{props.node.data.fullName}</h3>
          </div>
        ) : (
          ""
        )}
        {props.node.data.parentId === "" ? (
          <>
            <div
              className="node-card__chief-name-ellipsis"
              style={chiefNameEllipsis}
            >
              {props?.officeHierarchyId &&
              props?.officeHierarchyId === props.node.data.officeHierarchyId
                ? props.cardShow && (
                    <EllipsisDetailsCard
                      userPermission={props.userPermissions}
                      editPermission={props.editPermission}
                      deletePermission={props.deletePermission}
                      salesChartData={props.salesChartData}
                    />
                  )
                : ""}
              <div style={chiefCardName}>
                <div className="node-card__name">
                  <h3 className="truncate underline" style={cardNameH3}>
                    {props.node.data.fullName}{" "}
                  </h3>
                </div>

                <div className="text-sm font-base text-gray">
                  {props.node.data.employeeNumber !== ""
                    ? props.node.data.employeeNumber
                    : "0"}
                </div>
              </div>
              <div className="node-card__ellipsis" style={chiefCardEllipsis}>
                <EllipsisHorizontalCircleIcon
                  className={`h-6 w-6 rounded-full transition-colors duration-200 hover:text-white hover:bg-primary`}
                  style={{
                    color:
                      props.officeHierarchyId ===
                        props.node.data.officeHierarchyId &&
                      props.isClickedEllipsis
                        ? backgroundColor
                        : "",
                    backgroundColor:
                      props.officeHierarchyId ===
                        props.node.data.officeHierarchyId &&
                      props.isClickedEllipsis
                        ? textColor
                        : "",
                  }}
                />
              </div>
              <div className="rounded-full p-6 py-2" style={chiefIconUser}>
                <UserIcon
                  className={`text-chartColor rounded-full text-white`}
                  style={user}
                />
              </div>
            </div>
          </>
        ) : props.node.data.parentId === "1" ? (
          <div className="node-card__name-ellipsis" style={nameEllipsis}>
            {props.officeHierarchyId === props.node.data.officeHierarchyId
              ? props.cardShow && (
                  <EllipsisDetailsCard
                    userPermission={props.userPermissions}
                    editPermission={props.editPermission}
                    deletePermission={props.deletePermission}
                    salesChartData={props.salesChartData}
                  />
                )
              : ""}

            <div style={cardName}>
              <div className="node-card__name">
                <h3 className="truncate underline" style={cardNameH3}>
                  {props.node.data.fullName}{" "}
                </h3>
              </div>
              <div className="text-sm font-base text-gray ">
                {props.node.data.employeeNumber !== ""
                  ? props.node.data.employeeNumber
                  : "0"}
              </div>
            </div>
            <div>
              <div className="node-card__ellipsis" style={cardEllipsis}>
                <EllipsisHorizontalCircleIcon
                  className={`h-6 w-6 rounded-full transition-colors duration-200 hover:text-white hover:bg-primary`}
                  style={{
                    color:
                      props.officeHierarchyId ===
                        props.node.data.officeHierarchyId &&
                      props.isClickedEllipsis
                        ? backgroundColor
                        : "",
                    backgroundColor:
                      props.officeHierarchyId ===
                        props.node.data.officeHierarchyId &&
                      props.isClickedEllipsis
                        ? textColor
                        : "",
                  }}
                />
              </div>
              <div className="rounded-full p-6 py-2" style={iconUser}>
                <UserIcon
                  className={`text-chartColor rounded-full text-white`}
                  style={user}
                />
              </div>
            </div>
          </div>
        ) : props.node.data.parentId === "2" ? (
          <div className="node-card__name-ellipsis" style={nameEllipsis}>
            {props.officeHierarchyId === props.node.data.officeHierarchyId
              ? props.cardShow && (
                  <EllipsisDetailsCard
                    userPermission={props.userPermissions}
                    editPermission={props.editPermission}
                    deletePermission={props.deletePermission}
                    salesChartData={props.salesChartData}
                  />
                )
              : ""}
            <div style={cardName}>
              <div className="node-card__name">
                <h3 className="truncate underline" style={cardNameH3}>
                  {props.node.data.fullName}{" "}
                </h3>
              </div>
              <div className="text-sm font-base text-gray ">
                {props.node.data.employeeNumber !== ""
                  ? props.node.data.employeeNumber
                  : "0"}
              </div>
            </div>

            <div className="node-card__ellipsis" style={cardEllipsis}>
              <EllipsisHorizontalCircleIcon
                className={`h-6 w-6 rounded-full transition-colors duration-200 hover:text-white hover:bg-primary`}
                style={{
                  color:
                    props.officeHierarchyId ===
                      props.node.data.officeHierarchyId &&
                    props.isClickedEllipsis
                      ? backgroundColor
                      : "",
                  backgroundColor:
                    props.officeHierarchyId ===
                      props.node.data.officeHierarchyId &&
                    props.isClickedEllipsis
                      ? textColor
                      : "",
                }}
              />
            </div>

            <div className="rounded-full bg-primary p-6 py-2" style={iconUser}>
              <UserIcon
                className={`text-chartColor rounded-full text-white`}
                style={user}
              />
            </div>
          </div>
        ) : props.node.data.parentId === "3" ? (
          <div className="node-card__name-ellipsis" style={nameEllipsis}>
            {props.officeHierarchyId === props.node.data.officeHierarchyId
              ? props.cardShow && (
                  <EllipsisDetailsCard
                    userPermission={props.userPermissions}
                    editPermission={props.editPermission}
                    deletePermission={props.deletePermission}
                    salesChartData={props.salesChartData}
                  />
                )
              : ""}
            <div style={cardName}>
              <div className="node-card__name">
                <h3 className="truncate underline" style={cardNameH3}>
                  {props.node.data.fullName}{" "}
                </h3>
              </div>
              <div className="text-sm font-base text-gray ">
                {props.node.data.employeeNumber !== ""
                  ? props.node.data.employeeNumber
                  : "0"}
              </div>
            </div>
            <div>
              <div className="node-card__ellipsis" style={cardEllipsis}>
                <EllipsisHorizontalCircleIcon
                  className={`h-6 w-6 rounded-full transition-colors duration-200 hover:text-white hover:bg-primary`}
                  style={{
                    color:
                      props.officeHierarchyId ===
                        props.node.data.officeHierarchyId &&
                      props.isClickedEllipsis
                        ? backgroundColor
                        : "",
                    backgroundColor:
                      props.officeHierarchyId ===
                        props.node.data.officeHierarchyId &&
                      props.isClickedEllipsis
                        ? textColor
                        : "",
                  }}
                />
              </div>
            </div>
            <div className="rounded-full bg-primary p-6 py-2" style={iconUser}>
              <UserIcon
                className={`text-chartColor rounded-full text-white`}
                style={user}
              />
            </div>
          </div>
        ) : props.node.data.parentId === "4" ? (
          <div className="node-card__name-ellipsis" style={nameEllipsis}>
            {props.officeHierarchyId === props.node.data.officeHierarchyId
              ? props.cardShow && (
                  <EllipsisDetailsCard
                    userPermission={props.userPermissions}
                    editPermission={props.editPermission}
                    deletePermission={props.deletePermission}
                    salesChartData={props.salesChartData}
                  />
                )
              : ""}
            <div style={cardName}>
              <div className="node-card__name">
                <h3 className="truncate underline" style={cardNameH3}>
                  {props.node.data.fullName}{" "}
                </h3>
              </div>
              <div className="text-sm font-base text-gray ">
                {props.node.data.employeeNumber !== ""
                  ? props.node.data.employeeNumber
                  : "0"}
              </div>
            </div>

            <div>
              <div className="node-card__ellipsis" style={cardEllipsis}>
                <EllipsisHorizontalCircleIcon
                  className={`h-6 w-6 rounded-full transition-colors duration-200 hover:text-white hover:bg-primary`}
                  style={{
                    color:
                      props.officeHierarchyId ===
                        props.node.data.officeHierarchyId &&
                      props.isClickedEllipsis
                        ? backgroundColor
                        : "",
                    backgroundColor:
                      props.officeHierarchyId ===
                        props.node.data.officeHierarchyId &&
                      props.isClickedEllipsis
                        ? textColor
                        : "",
                  }}
                />
              </div>
            </div>
            <div className="rounded-full bg-primary p-6 py-2" style={iconUser}>
              <UserIcon
                className={`text-chartColor rounded-full text-white`}
                style={user}
              />
            </div>
          </div>
        ) : props.node.data.areaType === "Area" ? (
          <div className="node-card__name-ellipsis" style={nameEllipsis}>
            {props.officeHierarchyId === props.node.data.officeHierarchyId
              ? props.cardShow && (
                  <EllipsisDetailsCard
                    userPermission={props.userPermissions}
                    editPermission={props.editPermission}
                    deletePermission={props.deletePermission}
                    salesChartData={props.salesChartData}
                  />
                )
              : ""}
            <div style={cardName}>
              <div className="node-card__name">
                <h3 className="truncate underline" style={cardNameH3}>
                  {props.node.data.fullName}{" "}
                </h3>
              </div>
              <div className="text-sm font-base text-gray ">
                {props.node.data.employeeNumber !== ""
                  ? props.node.data.employeeNumber
                  : "0"}
              </div>
            </div>
            <div>
              <div className="node-card__ellipsis" style={cardEllipsis}>
                <EllipsisHorizontalCircleIcon
                  className={`h-6 w-6 rounded-full transition-colors duration-200 hover:text-white hover:bg-primary`}
                  style={{
                    color:
                      props.officeHierarchyId ===
                        props.node.data.officeHierarchyId &&
                      props.isClickedEllipsis
                        ? backgroundColor
                        : "",
                    backgroundColor:
                      props.officeHierarchyId ===
                        props.node.data.officeHierarchyId &&
                      props.isClickedEllipsis
                        ? textColor
                        : "",
                  }}
                />
              </div>
            </div>
            <div className="rounded-full bg-primary p-6 py-2" style={iconUser}>
              <UserIcon
                className={`text-chartColor rounded-full text-white`}
                style={user}
              />
            </div>
          </div>
        ) : (
          ""
        )}
        <div
          className="node-card__type"
          style={props.node.data.parentId === "" ? chiefCardType : cardType}
        >
          {props.node.data.territoryType === "Territory"
            ? props.node.data.territoryManagerTitle
            : props.node.data.areaType === "Area"
            ? props.node.data.areaManagerTitle
            : ""}
        </div>
        {props.node.data.parentId !== "" ? (
          <>
            <div className="node-card__officeHierarchy" style={officeHierarchy}>
              {props.node.data.parentId === ""
                ? ""
                : props.node.data.territoryType === "Territory"
                ? props.node.data.territoryCode.replace("-", "") +
                  " - " +
                  props.node.data.name
                : props.node.data.areaType === "Area"
                ? props.node.data.areaCode.replace("-", "") +
                  " - " +
                  props.node.data.areaName
                : ""}
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

OHSalesOrgChartNode.propTypes = {};

export default OHSalesOrgChartNode;
